module.exports = __webpack_public_path__ + "media/assets/images/shield-adf10e36a560bbd32328d007f73d501d.svg";